import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function leadBankStatementDataReducer(state = initialState.leadBankStatementData, action) {
  switch (action.type) {
    case types.LOAD_LEAD_BANK_STATEMENT_DATA_SUCCESS:
      return action.leadBankStatementData;
    default:
      return state;
  }
}
